mediator = require 'mediator'
DocumentSectionsV2Actions = require 'actions/document_sections_v2_actions'
{ PLACEMENT_BEFORE, PLACEMENT_AFTER } = require 'lib/document_sections_v2_helper'

module.exports =
  dragSpec:
    beginDrag: (props) ->
      chapterId: props.chapter.get('_id')
      initialParentId: props.chapter.get('parent')
      index: props.index
      ancestors: props.ancestors
    endDrag: (props, monitor) ->
      item = monitor.getItem()
      dropResult = monitor.getDropResult()
      if !dropResult
        return
      if dropResult.chapterId is item.chapterId
        DocumentSectionsV2Actions.saveMovedChapter(
          mediator.project.id, item.chapterId, item.initialParentId
        )
      else
        DocumentSectionsV2Actions.changeChapterParentId(
          mediator.project.id, item.chapterId, item.initialParentId, dropResult.chapterId
        )

    isDragging: (props, monitor) ->
      props.chapter.get('_id') is monitor.getItem().chapterId

  dropSpec:
    hover: (props, monitor, component) ->
      if !component
        return
      node = component.item
      if !node
        return
      draggingItem = monitor.getItem()
      dragIndex = draggingItem.index
      hoverIndex = props.index
      if dragIndex is hoverIndex
        return
      hoverBoundingRect = node.getBoundingClientRect()
      hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      clientOffset = monitor.getClientOffset()
      hoverClientY = clientOffset.y - hoverBoundingRect.top
      if dragIndex < hoverIndex && hoverClientY < hoverMiddleY
        return
      if dragIndex > hoverIndex && hoverClientY > hoverMiddleY
        return
      if props.ancestors.includes draggingItem.chapterId
        return
      hoverChapterId = props.chapter.get('_id')
      placement = if dragIndex < hoverIndex then PLACEMENT_AFTER else PLACEMENT_BEFORE
      DocumentSectionsV2Actions.moveChapter({
        chapterId: draggingItem.chapterId,
        referredChapterId: hoverChapterId,
        placement
      })
      draggingItem.index = hoverIndex
    drop: (props, monitor, component) ->
      chapterId: props.chapter.get('_id')
    canDrop: (props, monitor) ->
      draggingItem = monitor.getItem()
      !props.ancestors.includes draggingItem.chapterId

  dragCollect: (connect, monitor) ->
    connectDragSource: connect.dragSource()
    isDragging: monitor.isDragging()

  dropCollect: (connect, monitor) ->
    connectDropTarget: connect.dropTarget()
    isOver: monitor.isOver()
